import React, { useContext, useEffect, useState } from "react";
import { Box } from "theme-ui";
import moment from "moment-timezone";
import UserContext from "context/User";
import { AnnouncementHistoryItem, getUserAnnouncementHistory } from "api/Announcements";

// One line per announcement this person was shown, for the user's record.
// Staff only; renders nothing for other viewers or when there is no history.
const describe = (h: AnnouncementHistoryItem): string => {
	const parts: string[] = [];
	parts.push(h.firstShownAt ? `seen ${moment(h.firstShownAt).format("MMM D")}` : "not seen");
	if (h.timesShown > 1) parts.push(`shown ${h.timesShown}×`);
	if (h.reachedEndAt) parts.push("read to end");
	if (h.clickedAt) parts.push(`clicked ${h.actionLabel || "the button"}`);
	else if (h.acknowledgedAt) parts.push("got it");
	else if (h.laterCount > 0) parts.push(`later ×${h.laterCount}`);
	else if (h.closedAt) parts.push("closed");
	return parts.join(" · ");
};

const AnnouncementHistory: React.FC<{ userId?: string | null }> = ({ userId }) => {
	const { user } = useContext(UserContext) as any;
	const staff = user?.accessLevel === "isCompany" || user?.accessLevel === "isSuper";
	const [items, setItems] = useState<AnnouncementHistoryItem[]>([]);

	useEffect(() => {
		let live = true;
		setItems([]);
		if (staff && userId) void getUserAnnouncementHistory(String(userId)).then((r) => { if (live) setItems(r); });
		return () => { live = false; };
	}, [staff, userId]);

	if (!staff || items.length === 0) return null;
	return (
		<Box sx={{ mt: "8px", mb: "20px", fontSize: "13px", color: "#444" }}>
			<Box sx={{ fontSize: "11px", fontWeight: 600, letterSpacing: "0.5px", color: "#6B6B6B", mb: "6px" }}>{"WHAT'S NEW POP-UPS"}</Box>
			{items.map((h) => (
				<Box key={h.announcementId} sx={{ py: "4px", borderTop: "1px solid #ECECEA" }}>
					<Box as="span" sx={{ fontWeight: 500, color: "#111" }}>{h.title}</Box>
					<Box as="span">{` — ${describe(h)}`}</Box>
				</Box>
			))}
		</Box>
	);
};

export default AnnouncementHistory;
